module.exports = "<div *ngIf=\"isLoading | async\"></div>\r\n"